import { useRef, useState } from "react";
import Logo from "../Images/Cert-Logo.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useRegisterUserMutation } from "../Redux/auth/authApis";
import { FaCamera } from "react-icons/fa";

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    month: "",
    date: "",
    year: "",
    gender: "",
    companyName: "",
    designation: "",
    companyAddress: "",
    phoneNumber: "",
    contactNumber: "",
    role: "User",
    photo: null,
    ID: null,
  });

  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const navigate = useNavigate();
  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraField, setCameraField] = useState(null);
  const cameraRef = useRef(null);
  const [registerUser] = useRegisterUserMutation();

  const steps = [
    "Enter Name",
    "Basic Information",
    "Contact Information",
    "Sign-In Details",
    "Company Information",
    "Identity verification",
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateStep1 = () => {
    const newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required.";
    } else if (formData.firstName.length < 2) {
      newErrors.firstName = "First name must be at least 2 characters.";
    } else if (!nameRegex.test(formData.firstName)) {
      newErrors.firstName = "First name can only contain alphabets or spaces.";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required.";
    } else if (formData.lastName.length < 2) {
      newErrors.lastName = "Last name must be at least 2 characters.";
    } else if (!nameRegex.test(formData.lastName)) {
      newErrors.lastName = "Last name can only contain alphabets or spaces.";
    }

    return newErrors;
  };

  const validateStep2 = () => {
    const newErrors = {};
    const currentYear = new Date().getFullYear();
    const isLeapYear = (year) =>
      (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

    if (!formData.month) {
      newErrors.month = "Select the month.";
    }

    const maxDaysInMonth = {
      January: 31,
      February: isLeapYear(formData.year) ? 29 : 28,
      March: 31,
      April: 30,
      May: 31,
      June: 30,
      July: 31,
      August: 31,
      September: 30,
      October: 31,
      November: 30,
      December: 31,
    };

    if (
      !formData.date ||
      isNaN(formData.date) ||
      formData.date < 1 ||
      (formData.month && formData.date > maxDaysInMonth[formData.month])
    ) {
      newErrors.date = "Valid date is required for the selected month.";
    }

    if (
      !formData.year ||
      isNaN(formData.year) ||
      formData.year.toString().length !== 4
    ) {
      newErrors.year = "Valid year is required (e.g., 1990).";
    } else if (parseInt(formData.year) > currentYear) {
      newErrors.year = `Year cannot exceed ${currentYear}.`;
    } else if (parseInt(formData.year) < 1900) {
      newErrors.year = "Year cannot be earlier than 1900.";
    }

    if (
      !formData.gender ||
      !["male", "female", "other"].includes(formData.gender.toLowerCase())
    ) {
      newErrors.gender = "Gender is required.";
    }

    return newErrors;
  };

  const validateStep3 = () => {
    const newErrors = {};
    // const phoneRegex = /^\+?[1-9]\d{10,14}$/;

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone Number is required.";
    }
    // else if (!phoneRegex.test(formData.phoneNumber)) {
    //   newErrors.phoneNumber =
    //     "Phone Number must include a valid country code (e.g., +1) and valid digits only.";
    // }

    return newErrors;
  };

  const validateStep4 = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.emailAddress) {
      newErrors.emailAddress = "Email is required.";
    } else if (!emailRegex.test(formData.emailAddress)) {
      newErrors.emailAddress = "Please enter a valid email address.";
    }

    return newErrors;
  };

  const validateStep5 = () => {
    const newErrors = {};
    if (!formData.companyName) {
      newErrors.companyName = "Company Name is required.";
    }
    if (!formData.companyAddress) {
      newErrors.companyAddress = "Company Address is required.";
    }
    if (!formData.designation) {
      newErrors.designation = "Designation is required.";
    }
    return newErrors;
  };

  const handleNext = () => {
    let validationErrors = {};
    if (currentStep === 1) validationErrors = validateStep1();
    else if (currentStep === 2) validationErrors = validateStep2();
    else if (currentStep === 3) validationErrors = validateStep3();
    else if (currentStep === 4) validationErrors = validateStep4();
    else if (currentStep === 5) validationErrors = validateStep5();

    if (Object.keys(validationErrors).length === 0) {
      setErrors({});
      setCompletedSteps([...completedSteps, currentStep]);
      setCurrentStep(currentStep + 1);
    } else {
      setErrors(validationErrors);
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phoneNumber: value });
  };

  const handleSubmit = async () => {
    try {
      const submitData = new FormData();

      submitData.append("firstName", formData.firstName);
      submitData.append("lastName", formData.lastName);
      submitData.append("month", formData.month);
      submitData.append("date", formData.date);
      submitData.append("year", formData.year);
      submitData.append("gender", formData.gender);
      submitData.append("emailAddress", formData.emailAddress);  
      submitData.append("phoneNumber", formData.phoneNumber);
      submitData.append(
        "contactNumber",
        formData.contactNumber || formData.phoneNumber,
      );
      submitData.append("companyName", formData.companyName);
      submitData.append("companyAddress", formData.companyAddress);
      submitData.append("designation", formData.designation);
      submitData.append("role", formData.role);

      if (formData.photo) {
        submitData.append("photo", formData.photo);
      }
      if (formData.ID) {
        submitData.append("ID", formData.ID);
      }

      await registerUser(submitData).unwrap();

      toast.success("Registration successful!");
      navigate("/home");
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(
        error?.data?.message || "Registration failed. Please try again.",
      );
    }
  };

  const handleOpenCamera = (field) => {
    setCameraField(field);
    setCameraOpen(true);
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        if (cameraRef.current) {
          cameraRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        console.error("Camera access denied:", err);
        toast.error("Camera access denied");
      });
  };

  const handleCancelCamera = () => {
    setCameraOpen(false);
    stopCameraStream();
  };

  const handleCapturePhoto = (field) => {
    const video = cameraRef.current;
    if (video) {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL("image/png");

      stopCameraStream();

      const fileName = field === "photo" ? "profile.png" : "identity.png";
      const byteString = atob(dataUrl.split(",")[1]);
      const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
      const arrayBuffer = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        arrayBuffer[i] = byteString.charCodeAt(i);
      }
      const mockFile = new File([arrayBuffer], fileName, { type: mimeString });

      setFormData((prev) => ({
        ...prev,
        [field]: mockFile,
        [`${field}Preview`]: dataUrl,
      }));

      setCameraOpen(false);
      setCameraField(null);
    }
  };

  const stopCameraStream = () => {
    const stream = cameraRef.current?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prev) => ({
          ...prev,
          [name]: files[0],
          [`${name}Preview`]: e.target.result,
        }));
      };
      reader.readAsDataURL(files[0]);
    }
  };

  return (
    <div className="relative flex justify-center items-center h-screen overflow-hidden bg-red-100/90">
      {/* Soft Warm Glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#FDF6EC]/40 via-transparent to-[#FAF3E8]/40"></div>

      {/* Optional Glow Blobs */}
      <div className="absolute -top-20 -left-20 w-[350px] h-[350px] bg-[#F7EBDD]/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-[#F3E4D7]/40 rounded-full blur-3xl"></div>

      <div
        className="backdrop-blur-md bg-white/80 shadow-xl border-2 border-gray-200 rounded-3xl px-10 py-6 w-[920px] z-10"
        style={{ minHeight: 520 }}
      >
        <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-60 -mt-6" />

        <div className="flex justify-between items-center mb-6 mt-2">
          <img src={Logo} className="h-[52px]" alt="Logo" />
        </div>

        <div className="flex items-center justify-between mb-10 flex-wrap gap-4">
          {" "}
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex items-center gap-2 ${
                index + 1 === currentStep
                  ? "text-red-600"
                  : completedSteps.includes(index + 1)
                    ? "text-green-700"
                    : "text-gray-800"
              }`}
            >
              <div
                className={`w-6 h-6 rounded-full flex justify-center items-center border-2 text-sm font-semibold ${
                  index + 1 === currentStep
                    ? "border-red-500 bg-red-50"
                    : completedSteps.includes(index + 1)
                      ? "border-green-700 bg-green-100"
                      : "border-gray-400 bg-white"
                }`}
              >
                {completedSteps.includes(index + 1) ? (
                  <svg
                    className="w-4 h-4 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2.5}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <p className="text-xs hidden sm:block">{step}</p>
              {index < steps.length - 1 && (
                <div className="w-3 border-b hidden " />
              )}
            </div>
          ))}
          <div className="mt-2 w-full h-px bg-gradient-to-r from-red-500 to-red-700 rounded-full"></div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between mt-4 gap-10">
          <div className="flex flex-col justify-center pr-4  px-2 -mt-28">
            {currentStep === 1 && (
              <>
                <h1 className=" text-4xl text-gray-900 font-medium leading-tight mb-4 ">
                  Create your
                  <br />
                  Account
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Welcome! Let's begin with your name.
                </p>
              </>
            )}

            {currentStep === 2 && (
              <>
                <h1 className="text-4xl text-gray-900 leading-tight mb-4">
                  Basic
                  <br />
                  Information
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Tell us your date of birth and gender.
                </p>
              </>
            )}

            {currentStep === 3 && (
              <>
                <h1 className="text-4xl text-gray-900 leading-tight mb-4">
                  Contact <br />
                  Information
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Provide a phone number.
                </p>
              </>
            )}

            {currentStep === 4 && (
              <>
                <h1 className="text-4xl text-gray-900 leading-tight mb-4">
                  How you'll <br /> sign in
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Enter your email address - this will be your login credential.
                </p>
              </>
            )}

            {currentStep === 5 && (
              <>
                <h1 className="text-4xl text-gray-900 leading-tight mb-4">
                  Company <br /> Information
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Share your workplace details to complete your professional
                  profile.
                </p>
              </>
            )}

            {currentStep === 6 && (
              <>
                <h1 className="text-4xl text-gray-900 leading-tight mb-4">
                  Identity <br /> Verification
                </h1>
                <p className="text-gray-700 text-sm leading-relaxed">
                  Upload a profile photo and an identity proof to verify your
                  account(Optional).
                </p>
              </>
            )}
          </div>

          <div className="flex flex-col w-full sm:w-1/2 px-2 mt-4">
            {currentStep === 1 && (
              <>
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    autoComplete="off"
                    maxLength={40}
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.firstName ? "border-red-500" : "border-gray-400"
                    }`}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.firstName}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    autoComplete="off"
                    maxLength={40}
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.lastName ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.lastName}
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-end mt-4">
                  <button
                    onClick={handleNext}
                    className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                  >
                    Next
                  </button>
                </div>
                <p className="mt-6 text-center text-sm text-gray-700">
                  Already have an account?{" "}
                  <span
                    className="text-blue-700 font-semibold hover:text-blue-800 cursor-pointer"
                    onClick={handleLogin}
                  >
                    Login
                  </span>
                </p>
              </>
            )}

            {currentStep === 2 && (
              <>
                <div>
                  <label className="block text-gray-700 text-sm font-bold">
                    Date of Birth
                  </label>

                  <div className="mb-4 flex flex-row gap-2 pt-5">
                    <div>
                      <select
                        name="month"
                        value={formData.month}
                        onChange={handleChange}
                        className=" px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition"
                      >
                        <option value="">Month</option>
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </select>
                      {errors.month && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.month}
                        </p>
                      )}
                    </div>
                    <div>
                      <input
                        type="text"
                        name="date"
                        placeholder="Date"
                        value={formData.date}
                        onChange={handleChange}
                        autoComplete="off"
                        maxLength={2}
                        className="w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition"
                      />
                      {errors.date && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.date}
                        </p>
                      )}
                    </div>
                    <div>
                      <input
                        type="text"
                        name="year"
                        placeholder="Year"
                        value={formData.year}
                        onChange={handleChange}
                        autoComplete="off"
                        maxLength={4}
                        className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                          errors.year ? "border-red-500" : "border-gray-300"
                        }`}
                      />
                      {errors.year && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.year}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Gender
                  </label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition"
                  >
                    <option value="">Gender</option>
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                    <option value="Other">Rather not Say</option>
                    <option value="Others">Others</option>
                  </select>
                  {errors.gender && (
                    <p className="text-red-500 text-sm mt-1">{errors.gender}</p>
                  )}
                </div>
                <div className="flex items-center justify-end">
                  <button
                    onClick={handleNext}
                    className="w-full sm:w-auto bg-gradient-to-r  from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition mt-4"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {currentStep === 3 && (
              <>
                <div className="mb-4 pt-5">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Contact Number
                  </label>
                  <PhoneInput
                    country={"in"}
                    value={formData.phoneNumber}
                    onChange={handlePhoneChange}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.phoneNumber}
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-end mt-4">
                  <button
                    onClick={handleNext}
                    className="w-full sm:w-auto bg-gradient-to-r  from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {currentStep === 4 && (
              <>
                <div className="mb-4 pt-5">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="emailAddress"
                    value={formData.emailAddress}
                    placeholder="you@example.com"
                    onChange={handleChange}
                    autoComplete="off"
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.emailAddress ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.emailAddress && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.emailAddress}
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-end mt-4">
                  <button
                    onClick={handleNext}
                    className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {currentStep === 5 && (
              <>
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Company Name
                  </label>
                  <input
                    type="text"
                    name="companyName"
                    placeholder="Company Name"
                    maxLength={50}
                    value={formData.companyName}
                    onChange={handleChange}
                    autoComplete="off"
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.companyName ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.companyName}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Company Address
                  </label>
                  <input
                    type="text"
                    name="companyAddress"
                    placeholder="Company Address (ex: Bangalore)"
                    value={formData.companyAddress}
                    onChange={handleChange}
                    maxLength={60}
                    autoComplete="off"
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.companyAddress
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.companyAddress && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.companyAddress}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Designation
                  </label>
                  <input
                    type="text"
                    name="designation"
                    placeholder="Designation"
                    maxLength={40}
                    value={formData.designation}
                    onChange={handleChange}
                    autoComplete="off"
                    className={`w-full px-4 py-3 border rounded-xl border-gray-400 focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-600 transition ${
                      errors.designation ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.designation && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.designation}
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-end mt-4">
                  <button
                    onClick={handleNext}
                    className="w-full sm:w-auto bg-gradient-to-r  from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {currentStep === 6 && (
              <>
                {!cameraOpen ? (
                  <>
                    <div className="mb-5 mt-2">
                      <label className="block text-gray-700 text-sm font-bold mb-2">
                        Upload your Profile Photo{" "}
                        <span className="text-xs font-semibold">
                          (Optional)
                        </span>
                      </label>
                      <div className="relative">
                        <input
                          type="file"
                          accept="image/*"
                          name="photo"
                          onChange={handleFileChange}
                          autoComplete="off"
                          className="w-full px-4 py-3 border border-gray-500 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm"
                        />
                        <button
                          type="button"
                          onClick={() => handleOpenCamera("photo")}
                          className="absolute right-2 top-2 text-xs px-3 py-2  text-white rounded-lg "
                        >
                          <FaCamera className="text-blue-600 hover:text-blue-700 text-xl" />
                        </button>
                      </div>
                      {formData.photo && (
                        <div className="mt-1 flex items-center gap-2">
                          <img
                            src={formData.photoPreview}
                            alt="Profile preview"
                            className="w-12 h-12 object-cover rounded border"
                          />
                          <p className="text-xs text-gray-700 truncate flex-1">
                            {formData.photo.name}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="block text-gray-700 text-sm font-bold mb-2">
                        Upload Identity Proof{" "}
                        <span className="text-xs font-semibold">
                          (Optional)
                        </span>
                      </label>
                      <div className="relative">
                        <input
                          type="file"
                          accept="image/*"
                          name="ID"
                          onChange={handleFileChange}
                          autoComplete="off"
                          className="w-full px-4 py-3 border border-gray-500 rounded-xl focus:ring-2 focus:ring-red-500 outline-none text-sm"
                        />
                        <button
                          type="button"
                          onClick={() => handleOpenCamera("ID")}
                          className="absolute right-2 top-2 text-xs px-3 py-2  text-white rounded-lg "
                        >
                          <FaCamera className="text-blue-600 hover:text-blue-700 text-xl" />
                        </button>
                      </div>
                      {formData.ID && (
                        <div className="mt-1 flex items-center gap-2">
                          <img
                            src={formData.IDPreview}
                            alt="ID preview"
                            className="w-12 h-12 object-cover rounded border"
                          />
                          <p className="text-xs text-gray-700 truncate flex-1">
                            {formData.ID.name}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center justify-end mt-4">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full sm:w-auto bg-gradient-to-r  from-red-600 to-red-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                      >
                        Submit
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="relative bg-gray-50 p-4 rounded-lg">
                    <video
                      ref={cameraRef}
                      autoPlay
                      className="border rounded-lg w-full h-48"
                    />
                    <div className="flex justify-between mt-4">
                      <button
                        type="button"
                        onClick={handleCancelCamera}
                        className="bg-gray-600 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={() => handleCapturePhoto(cameraField)}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                      >
                        Capture & Upload
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
